import React, { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state to indicate an error occurred
    console.error('getDerivedStateFromError Error:', error);
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can log the error or perform additional actions here
    console.error('Error:', error);
    console.error('Error Info:', errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render a custom fallback UI when an error occurs
      return <h1>Something went wrong.</h1>;
    }

    // Render the children if there is no error
    return this.props.children;
  }
}

export default ErrorBoundary;
